import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Analytics from './Analytics';
import Billing from './Billing';
import Views from './Views';
export const UserProps = {
    id: types.maybe(types.integer),
    accountId: types.maybe(types.integer),
    firstName: types.maybe(types.string),
    lastName: types.maybe(types.string),
    countryCode: types.maybe(types.string),
    availableCredits: types.optional(types.integer, 0),
    totalCredits: types.optional(types.integer, 0),
    groupName: types.maybeNull(types.string),
    email: types.maybe(types.string),
    phone: types.maybe(types.string),
    hashedEmail: types.maybe(types.string),
    industry: types.maybe(types.string),
    accountStatus: types.maybe(types.string),
    accountStatusReason: types.maybe(types.string),
    accountDomain: types.maybe(types.string),
    isLoaded: types.optional(types.boolean, false),
    isAccountAdmin: types.optional(types.boolean, false),
    features: types.optional(types.array(types.optional(types.string, '')), []),
    bulkAvailableCredits: types.optional(types.integer, 0),
    billing: types.maybeNull(Billing),
    analytics: types.optional(Analytics, () => Analytics.create()),
    roleId: types.maybeNull(types.integer),
    isSearchByDataPointEnabled: types.optional(types.boolean, false),
    accountUnfreezeDate: types.optional(types.string, ''),
    subscriptionStatus: types.optional(types.string, ''),
};
const User = types.model(UserProps).actions(Actions).views(Views);
export default User;
